import { useAlbumContext } from '@/utils/hooks/context/useAlbumContext';
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Hooks
import useToggle from '@/utils/hooks/utils/useToggle';

import PropTypes from 'prop-types';

import Button from '@/components/base/Button';
// Components
import Modal from '@/components/base/Modal';
import DeleteAlbumModal from '@/components/pages/albums/DeleteAlbumModal';

const FooterModal = ({
    disableSubmitButton = false,
    submitStatus = {},
    submitAlbum = () => {
        /** */
    },
    onCancel = () => {
        /** */
    }
}) => {
    const { isOpen: isOpenDeleteModal, toggle: toggleDeleteModal } = useToggle();
    const { t } = useTranslation();
    const { albumInfo } = useAlbumContext();

    return (
        <Modal.Footer className="flex items-center justify-end gap-3 px-5 pb-8 pt-8 sm:px-15">
            {albumInfo?.id ? (
                <Button
                    variant="secondary"
                    className="w-48"
                    disabled={submitStatus?.isSubmitting}
                    onClick={toggleDeleteModal}>
                    {t('content:modal.edit_modal.delete')}
                </Button>
            ) : (
                <Button
                    variant="white"
                    className="w-48"
                    disabled={submitStatus?.isSubmitting}
                    onClick={onCancel}>
                    {t('commons:cancel')}
                </Button>
            )}
            <Button
                className="w-fit min-w-48"
                variant="primary"
                id="track-campaign-button"
                disabled={disableSubmitButton}
                isLoading={submitStatus?.isSubmitting}
                onClick={submitAlbum}>
                {albumInfo?.id
                    ? t('content:modal.edit_modal.edit')
                    : t('content:modal.create_modal.start_tracking')}
            </Button>
            <DeleteAlbumModal
                isOpen={isOpenDeleteModal}
                toggle={toggleDeleteModal}
                albumId={albumInfo?.id}
            />
        </Modal.Footer>
    );
};

FooterModal.propTypes = {
    disableSubmitButton: PropTypes.bool,
    submitStatus: PropTypes.object.isRequired,
    submitAlbum: PropTypes.func.isRequired,
    onCancel: PropTypes.func
};

export default FooterModal;
